var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component } from "vue-property-decorator";
import HTTP from "@/http";
import InputAudioTags from "@/components/Inputs/InputAudioTags";
import InputTrackArtist from "@/components/Inputs/InputTrackArtist";
import InputTrackTitle from "@/components/Inputs/InputTrackTitle";
import InputTrackSource from "@/components/Inputs/InputTrackSource";
import InputTrackLyricsSource from "@/components/Inputs/InputTrackLyricsSource";
import PageTitle from "@/components/PageTitle";
import Validate from "@/decorators/validate";
var PageTracksCreate = (function (_super) {
    __extends(PageTracksCreate, _super);
    function PageTracksCreate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.alert = true;
        _this.form = {
            artist: "",
            name: "",
            previewSource: "",
            lyricsSource: "",
            tags: [],
        };
        _this.providerTitle = "";
        return _this;
    }
    PageTracksCreate.prototype.swap = function () {
        _a = [this.form.name, this.form.artist], this.form.artist = _a[0], this.form.name = _a[1];
        var _a;
    };
    PageTracksCreate.prototype.autoFill = function (title) {
        this.providerTitle = title;
        var matches = title.match(/(.*)\s-\s(.*)/);
        this.form.artist = matches[1];
        this.form.name = matches[2];
    };
    PageTracksCreate.prototype.submit = function () {
        var _this = this;
        var params = this["$deepcopy"](this.form);
        params.tags = params.tags.map(function (tag) {
            return typeof tag === 'object' ? tag.name : tag;
        });
        params.type = "track";
        HTTP.post('audios', params).then(function (response) {
            _this.$router.push({ name: 'Track', params: { id: response.data.id } });
        }, function (response) {
        });
    };
    PageTracksCreate.prototype.created = function () {
        this.form.previewSource = this.$route.query.previewSource || "";
    };
    __decorate([
        Validate,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageTracksCreate.prototype, "submit", null);
    PageTracksCreate = __decorate([
        Component({
            components: {
                PageTitle: PageTitle,
                InputAudioTags: InputAudioTags,
                "input-track-artist": InputTrackArtist,
                "input-track-title": InputTrackTitle,
                "input-track-source": InputTrackSource,
                "input-track-lyrics-source": InputTrackLyricsSource,
            }
        })
    ], PageTracksCreate);
    return PageTracksCreate;
}(Vue));
export default PageTracksCreate;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pages/TracksCreate/PageTracksCreate.vue
// module id = 254
// module chunks = 0